import { createContext } from 'react';

const ConfigsContext = createContext();

export default ConfigsContext;